// #1981: vanaf een periodisering naar het toewijsscherm van de gekozen sporter
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["sporter"]

  ga(event) {
    event.preventDefault()
    const id = this.sporterTarget.value
    if (!id) {
      this.sporterTarget.focus()
      return
    }
    window.location.href = this.sporterTarget.dataset.pad.replace("SPORTER", encodeURIComponent(id))
  }
}
